import { catchError, lastValueFrom, map, of } from 'rxjs';
import { CpApi } from '../cp-api';
import { CpUserInfo, createCpUserInfoFromHttpJson } from '../models/cp-user-info';

export async function cpGetUserInfo(cpApi: CpApi): Promise<CpUserInfo | undefined> {
  return lastValueFrom(
    cpApi.http.get(`${cpApi.userApiUrl}info/`, cpApi.apiConfig.getUserAuthOptions()).pipe(
      map(createCpUserInfoFromHttpJson),
      catchError(() => of(createCpUserInfoFromHttpJson({ status: 'not_logged' })))
    )
  );
}
